import { useSaveActions } from "../../common"
import { TableName } from "../../../tables"
import { Delivery } from "../state/types"

export const useDeliveryActions = () => {
    const saveActions = useSaveActions()

    const saveDelivery = (delivery: Delivery) => {
        const { save } = saveActions()
        return save(TableName.DELIVERIES2, delivery) as Promise<Delivery>
    }

    const removeDelivery = (id: string) => {
        const { remove } = saveActions()
        return remove(TableName.DELIVERIES2, id)
    }

    return {
        saveDelivery,
        removeDelivery
    }
}
